function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "star_rated"
}, /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 27 (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5002 12.4997C13.2616 12.4997 15.5002 10.2611 15.5002 7.49967C15.5002 4.73825 13.2616 2.49967 10.5002 2.49967C7.73874 2.49967 5.50016 4.73825 5.50016 7.49967C5.50016 10.2611 7.73874 12.4997 10.5002 12.4997ZM10.5002 14.1663C14.1821 14.1663 17.1668 11.1816 17.1668 7.49967C17.1668 3.81778 14.1821 0.833008 10.5002 0.833008C6.81826 0.833008 3.8335 3.81778 3.8335 7.49967C3.8335 11.1816 6.81826 14.1663 10.5002 14.1663Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle 4278 (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.22175 10.5285C6.62033 10.7587 6.75689 11.2683 6.52677 11.6669L4.65009 14.8293L6.04512 14.913L6.81516 16.0793L8.52837 13.2219C8.75849 12.8233 9.26815 12.6868 9.66673 12.9169C10.0653 13.147 10.2019 13.6567 9.97175 14.0552L7.71919 17.8468C7.3475 18.4906 6.42825 18.5181 6.01865 17.8978L5.11343 16.5268L3.47348 16.4283C2.73144 16.3838 2.29568 15.5739 2.66737 14.9301L5.08339 10.8336C5.31351 10.435 5.82317 10.2984 6.22175 10.5285Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle 4279 (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.3331 12.9171C11.7317 12.687 12.2414 12.8235 12.4715 13.2221L14.1857 16.0795L14.9557 14.9132L16.3507 14.8295L14.4731 11.6671C14.243 11.2685 14.3795 10.7588 14.7781 10.5287C15.1767 10.2986 15.6863 10.4351 15.9165 10.8337L18.3334 14.9303C18.7051 15.5741 18.2694 16.384 17.5273 16.4285L15.8874 16.527L14.9822 17.898C14.5726 18.5183 13.6533 18.4908 13.2816 17.847L11.0281 14.0554C10.798 13.6569 10.9345 13.1472 11.3331 12.9171Z",
  fill: "white"
}));

function SvgRate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRate);
export default __webpack_public_path__ + "assets/media/rate.7f2fc5f4.svg";
export { ForwardRef as ReactComponent };